// class FreeShippingMeter extends HTMLElement {
//     constructor() {
//         super();
//     }

//     static freeShippingText = window.free_shipping_text.free_shipping_message;
//     static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;
//     static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;
//     static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;
//     static freeShippingText4 = window.free_shipping_text.free_shipping_message_4;
//     static classLabel1 = 'progress-30';
//     static classLabel2 = 'progress-60';
//     static classLabel3 = 'progress-100';
//     static freeshipPrice = parseInt(window.free_shipping_price);

//     connectedCallback() {
//         this.freeShippingEligible = 0;
//         this.progressBar = this.querySelector('[data-shipping-progress]');
//         this.messageElement = this.querySelector('[data-shipping-message]');
//         this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
//         this.shipVal = window.free_shipping_text.free_shipping_1;
//         this.progressMeter = this.querySelector('[ data-free-shipping-progress-meter]');

//         this.addEventListener('change', this.onCartChange.bind(this));

//         this.initialize();
//     }

//     initialize() {
//         Shopify.getCart((cart) => {
//             this.cart = cart;
//             this.calculateProgress(cart);
//         })
//     }

//     onCartChange(e) {
//         this.initialize();
//     }

//     calculateProgress(cart) {
//         const cartTotalPrice = parseInt(cart.total_price) / 100;
//         const cartTotalPriceFormatted = cartTotalPrice.toFixed(2);
//         const cartTotalPriceRounded = parseFloat(cartTotalPriceFormatted);

//         let freeShipBar = Math.abs((cartTotalPriceRounded * 100) / FreeShippingMeter.freeshipPrice);
//         if (freeShipBar >= 100) {
//             freeShipBar = 100;
//         }
        
//         const text = this.getText(cartTotalPriceFormatted, freeShipBar);
//         const classLabel = this.getClassLabel(freeShipBar);

//         this.setProgressWidthAndText(freeShipBar, text, classLabel);
//     }

//     getText(cartTotalPrice, freeShipBar) {
//         let text;

//         if (cartTotalPrice == 0) {
//             this.progressBar.classList.add('progress-hidden');
            
//             // BTL Original
//             // text = '<span>' + FreeShippingMeter.freeShippingText + ' ' + Shopify.formatMoney(FreeShippingMeter.freeshipPrice * 100, window.money_format) +'!</span>';
            
//             // BTL General Adjusted
//             // text = '<span>' + FreeShippingMeter.freeShippingText + ' $50!</span>';
//             // text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 12px;">Free shipping for all orders over $50!</span></p>';

//             // BTL B2G1 2024 Adjusted
//             // text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 11px;">Add 2 Snoods to your cart for:<br>FREE SHIPPING & a FREE 3rd SNOOD!</span></p>';

//             // BTL B2G1 no free shipping 2024 Adjusted
//             // text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 14px;line-height: 20.5px;">Add 2 Snoods to your cart for<br>A FREE 3RD SNOOD!</span></p>';

//             // BTL Halloween 2025 Adjusted
//             // text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 11px;">Add 3 Snoods to your cart and 1 will be marked down to FREE!</span></p>';

//             // But 3 get 1
//             text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 11px;">Add 4 Snoods to your cart and 1 will be marked down to FREE!</span></p>';

//         } else if (cartTotalPrice >= FreeShippingMeter.freeshipPrice) {
//             this.progressBar.classList.remove('progress-hidden');
//             this.freeShippingEligible = 1;

//             // BTL Original
//             // text = FreeShippingMeter.freeShippingText1;

//             // BTL General Adjusted
//             // text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 12px;">You qualify for FREE SHIPPING!</span><br><span style="color: #000;font-size: 12px;">(See details in checkout)</span></p>';

//             // BTL B2G1 2024 Adjusted
//             // text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 11px;">You&apos;re getting FREE SHIPPING and a FREE SNOOD!<br>Add a 3rd Snood if you haven&apos;t already!<br><span style="font-size: 10px;">(all other coupon codes must be removed at checkout)</span></span></p>';

//             // BTL B2G1 2024 Adjusted
//             // text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 14px;line-height: 20.5px;">You&apos;re eligible for a FREE SNOOD!<br><span style="color:#e95144;">Add a 3rd Snood if you haven&apos;t already!</span><br><span style="font-size: 11px; line-height: 26px;">(all other coupon codes must be removed at checkout)</span></span></p>';

//             // BTL Halloween 2025 Adjusted
//             // text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 11px;">You&apos;re getting a FREE SNOOD!<br>Add a 3rd Snood if you haven&apos;t already!<br><span style="font-size: 10px;">(all other coupon codes must be removed at checkout)</span></span></p>';

//             // But 3 get 1
//             text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 11px;">You&apos;re getting a FREE SNOOD!<br>Add a 4rd Snood if you haven&apos;t already!<br><span style="font-size: 10px;">(all other coupon codes must be removed at checkout)</span></span></p>';

//         } else {
//             this.progressBar.classList.remove('progress-hidden');
//             const remainingPrice = Math.abs(FreeShippingMeter.freeshipPrice - cartTotalPrice);

//             // BTL Original
//             // text = '<span>' + FreeShippingMeter.freeShippingText2 + ' </span>' + Shopify.formatMoney(remainingPrice * 100, window.money_format) + '<span> ' +  FreeShippingMeter.freeShippingText3 + ' </span><span class="text">' + FreeShippingMeter.freeShippingText4 + '</span>';
            
//             // BTL General
//             // text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 12px;">You&apos;re close to getting FREE SHIPPING!</span><br><span style="color: #000;font-size: 12px;">(You&apos;re cart total needs to be $50+)</span></p>';

//             // BTL B2G1 2024 Adjusted
//             // text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 11px;">Add 2 Snoods to your cart for:<br>FREE SHIPPING & a FREE 3rd SNOOD!</span></p>';

//             // BTL B2G1 no free shipping 2024 Adjusted
//             // text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 14px;line-height: 20.5px;">Add 2 Snoods to your cart for<br>A FREE 3RD SNOOD!</span></p>';

//             // BTL Halloween 2025 Adjusted
//             // text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 11px;">Add 3 Snoods to your cart and 1 will be marked down to FREE!</span></p>';

//             // But 3 get 1
//             text = '<p style="text-align:center"><span style="font-weight: bold;color: #000;font-size: 11px;">Add 4 Snoods to your cart and 1 will be marked down to FREE!</span></p>';

//             this.shipVal = window.free_shipping_text.free_shipping_2;
//         }

//         return text;
//     }

//     getClassLabel(freeShipBar) {
//         let classLabel;

//         if (freeShipBar === 0) {
//             classLabel = 'none';
//         } else if (freeShipBar <= 30) {
//             classLabel = FreeShippingMeter.classLabel1;
//         } else  if (freeShipBar <= 60) {
//             classLabel = FreeShippingMeter.classLabel2;
//         } else if (freeShipBar < 100) {
//             classLabel = FreeShippingMeter.classLabel3;
//         } else {
//             classLabel = 'progress-free'
//         }

//         return classLabel;
//     }
    
//     resetProgressClass(classLabel) {
//         this.progressBar.classList.remove('progress-30');
//         this.progressBar.classList.remove('progress-60');
//         this.progressBar.classList.remove('progress-100');
//         this.progressBar.classList.remove('progress-free');

//         this.progressBar.classList.add(classLabel);
//     }
    
//     setProgressWidthAndText(freeShipBar, text, classLabel) {
//         setTimeout(() => {
//             this.resetProgressClass(classLabel);

//             this.progressMeter.style.width = `${freeShipBar}%`;
//             if (this.textEnabled) {
//                 const textWrapper = this.progressMeter.querySelector('.text').innerHTML = `${freeShipBar}%`;
//             }

//             this.messageElement.innerHTML = text;

//             if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
//                 Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
//             }
//         }, 400)
//     }
// }

// window.addEventListener('load', () => {
//     customElements.define('free-shipping-component', FreeShippingMeter);
// })



class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }
    static freeShippingText = window.free_shipping_text.free_shipping_message;
    static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;
    static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;
    static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;
    static freeShippingText4 = window.free_shipping_text.free_shipping_message_4;
    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';
    
    static freeshipPrice = parseInt(window.free_shipping_price); 
    static freeshipItem = parseInt(window.free_shipping_item); 
    
    static isItemPropertyFilterEnabled = window.bar_line_for_collection_enabled || false; 

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.shipVal = window.free_shipping_text.free_shipping_1;
        this.progressMeter = this.querySelector('[ data-free-shipping-progress-meter]');
        
        this.shippingType = window.free_shipping_text.type_shipping || 'price'; 

        this.addEventListener('change', this.onCartChange.bind(this));
        this.initialize();
    }

    initialize() {
        Shopify.getCart((cart) => {
            this.cart = cart;
            this.calculateProgress(cart);
        })
    }

    onCartChange(e) {
        this.initialize();
    }
    
    countItemsWithProperty(cart) {
        let count = 0;

        if (!cart.items) {
            return 0;
        }
        
        cart.items.forEach(item => {
            const hasRequiredProperty = item.properties && item.properties.collection_bar;
            if (hasRequiredProperty) {
                count += item.quantity;
            }
        });

        return count;
    }

    calculateProgress(cart) {
        let targetValue;
        let targetThreshold;
        let isPriceMode = this.shippingType === 'price';

        if (isPriceMode) {
            let totalPrice = cart.total_price;
            
            if ($('body').hasClass('setup_shipping_delivery')) {
                const giftCardItems = $(".cart-item[data-price-gift-card], .previewCartItem[data-price-gift-card]");
                if (giftCardItems.length > 0) {
                    giftCardItems.each(function() {
                        totalPrice -= parseFloat($(this).attr("data-price-gift-card"));
                    });
                }
            }
            
            targetValue = parseInt(totalPrice) / 100; 
            targetThreshold = FreeShippingMeter.freeshipPrice;
            
        } else {
            targetThreshold = FreeShippingMeter.freeshipItem;

            if (FreeShippingMeter.isItemPropertyFilterEnabled) {
                targetValue = this.countItemsWithProperty(cart); 
            } else {
                targetValue = cart.item_count;
            }
        }

        const displayValue = isPriceMode ? parseFloat(targetValue.toFixed(2)) : targetValue;
        
        let freeShipBar = 0;
        if (targetThreshold > 0) {
             freeShipBar = Math.abs((displayValue / targetThreshold) * 100);
        }
        if (freeShipBar >= 100) {
            freeShipBar = 100;
        }
        const text = this.getText(displayValue, targetThreshold, freeShipBar, isPriceMode);
        const classLabel = this.getClassLabel(freeShipBar);

        this.setProgressWidthAndText(freeShipBar, text, classLabel);
    }

    getText(currentValue, targetThreshold, freeShipBar, isPriceMode) {
        let text;
        
        const formatValue = (val) => {
            if (isPriceMode) {
                return Shopify.formatMoney(val * 100, window.money_format);
            } else {
                return val + ' items';
            }
        }   
        // console.log("Total number of products in the shopping cart", currentValue);
        // console.log("Number of requests to receive a discount or gift", targetThreshold);

        if (currentValue == 0) {
            this.progressBar.classList.add('progress-hidden');
            const targetText = formatValue(targetThreshold);
            // text = '<span>' + FreeShippingMeter.freeShippingText + ' ' + targetText +'!</span>';
            text = "<span>Add 4 Snoods to your cart<br>and one will be marked free!</span>";
        } else if (currentValue > targetThreshold) {
            this.progressBar.classList.remove('progress-hidden');
            this.freeShippingEligible = 1;
            // text = FreeShippingMeter.freeShippingText1;
            text = "<span>You&apos;re getting a free snood!</span>";
        } else if (currentValue == targetThreshold) {
            this.progressBar.classList.remove('progress-hidden');
            this.freeShippingEligible = 1;
            // text = FreeShippingMeter.freeShippingText1;
            text = "<span>You&apos;re eligible for a free snood!<br>Add a 4rd snood to your cart and it&apos;s free!</span>";
        } else {
            this.progressBar.classList.remove('progress-hidden');
            const remainingValue = Math.abs(targetThreshold - currentValue);
            const remainingText = formatValue(remainingValue);
            // text = '<span>' + FreeShippingMeter.freeShippingText2 + ' </span>' + currentValue + '<span> ' +  FreeShippingMeter.freeShippingText3 + ' </span>' + remainingText + ' <span class="text">' + FreeShippingMeter.freeShippingText4 + '</span>';
            text = '<span>You&apos;re close to getting a free snood!<br>Keep adding to your cart!</span>';
            this.shipVal = window.free_shipping_text.free_shipping_2;
        }
        return text;
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar <= 30) {
            classLabel = FreeShippingMeter.classLabel1;
        } else  if (freeShipBar <= 60) {
            classLabel = FreeShippingMeter.classLabel2;
        } else if (freeShipBar < 100) {
            classLabel = FreeShippingMeter.classLabel3;
        } else {
            classLabel = 'progress-free'
        }
        return classLabel;
    }
    
    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('progress-30');
        this.progressBar.classList.remove('progress-60');
        this.progressBar.classList.remove('progress-100');
        this.progressBar.classList.remove('progress-free');
        this.progressBar.classList.add(classLabel);
    }
    
    setProgressWidthAndText(freeShipBar, text, classLabel) {
        setTimeout(() => {
            this.resetProgressClass(classLabel);
            this.progressMeter.style.width = `${freeShipBar}%`;
            if (this.textEnabled) {
                const isPriceMode = this.shippingType === 'price';
                const fixedDigits = isPriceMode ? 2 : 0; 
                const textWrapper = this.progressMeter.querySelector('.text').innerHTML = `${freeShipBar.toFixed(fixedDigits)}%`;
            }
            this.messageElement.innerHTML = text;
            if (this.shippingType === 'price' && $('.dropdown-item[data-currency]').length){
                if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
                    Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                }
            }
        }, 400)
    }
}

window.addEventListener('load', () => {
    customElements.define('free-shipping-component', FreeShippingMeter);
})